<template>
  <div>
    <add-assignment
      :dialogVisible="modals.showAddAssignment"
      v-on:closed="handleLeaveAssignment"
      v-on:done="handleCreateAssignmentSuccess"
      ref="addAssignment"
    />
    <leave-create-study-set-modal
      :dialogVisible="modals.showLeaveAssignment"
      append-to-body
      v-on:closed="modals.showLeaveAssignment = false"
      v-on:leave="handleConfirmLeaveAssignment"
    />
    <assign-to-class-success-modal
      :createdAssignments="createdAssignments"
      :dialogVisible="modals.showAssignToClassSuccess"
      append-to-body
      v-on:closed="handleReviewAssignmentSuccess"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddAssignment from "@/components/modals/read-aloud/AddAssignment";
import LeaveCreateStudySetModal from "@/components/modals/studysets/LeaveCreateStudySetModal";
import AssignToClassSuccessModal from "@/components/modals/studysets/AssignToClassSuccessModal";

export default {
  components: {
    AddAssignment,
    LeaveCreateStudySetModal,
    AssignToClassSuccessModal,
  },
  data() {
    return {
      modals: {
        showAddAssignment: false,
        showLeaveAssignment: false,
        showAssignToClassSuccess: false,
      },
      deleteStudySetId: -1,
      selectedStudySetToAssign: null,
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
    organizationData() {
      return this.$store.state.organization.currentOrganization;
    },
    ...mapGetters("organization", ["isOrganizationAdmin", "isOrganizationAssociateAdmin", "currentOrganizationType"]),
    ...mapGetters({
      createdAssignments: "readAlouds/getCreatedAssignments",
    }),
  },
  methods: {
    ...mapActions({
      deleteStudySetAction: "readAlouds/deleteStudySet",
    }),
    handleLeaveAssignment() {
      if (this.$refs.addAssignment.emptyCheck() == 1) this.modals.showLeaveAssignment = true;
      else this.modals.showAddAssignment = false;
    },
    handleConfirmLeaveAssignment() {
      this.$refs.addAssignment.reset();
      this.modals.showAddAssignment = false;
      this.modals.showLeaveAssignment = false;
    },
    handleCreateAssignmentSuccess() {
      this.$refs.addAssignment.reset();
      this.modals.showAddAssignment = false;
      this.modals.showLeaveAssignment = false;
      this.modals.showAssignToClassSuccess = true;
    },
    handleReviewAssignmentSuccess() {
      this.modals.showAssignToClassSuccess = false;
      this.$emit("reload");
    },
    handleAssignToClassReadAloud(data) {
      this.$refs.addAssignment.setInitialReadAloud(data);
      this.modals.showAddAssignment = true;
    },
    handleAssignToClassStudySets(studySets) {
      this.$refs.addAssignment.setInitialStudySets(studySets);
      this.modals.showAddAssignment = true;
    },
    handleAssignAssessmentToClass(assessment) {
      this.$refs.addAssignment.setInitialAssessment(assessment);
      this.modals.showAddAssignment = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";
.study-set-container {
  width: 100%;
  font-family: "SF Pro Display", sans-serif;
  .study-set-tab-body {
    padding: 24px 40px;
    text-align: center;
    padding-bottom: 0px;
  }
  .create-new-study-set {
    button {
      background: #007eff;
      border-radius: 8px;
      border: none;
      color: #fff;
      padding: 16px;
      font-size: 16px;
      max-width: 230px;
      cursor: pointer;
    }
  }
  .el-table .el-table__row .wrap-avatar small {
    font-size: 16px;
  }
  .elsa-table-layout-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    & > div {
      align-self: center;
    }
  }
  .status__label {
    font-size: 16px;
    text-transform: capitalize;
    padding-left: 10px;
  }
  .status__input {
    vertical-align: middle;
    .status__inner {
      border: 1px solid #dcdfe6;
      border-radius: 100%;
      width: 14px;
      height: 14px;
      background-color: #fff;
      cursor: pointer;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      position: relative;
      display: inline-block;
    }
  }
  .status__active .status__inner {
    border-color: #03bd23;
    background-color: #03bd23;
  }
  .status__finished .status__inner {
    border-color: #e6a23c;
    background-color: #e6a23c;
  }
  .status__not_started .status__inner {
    border-color: #909399;
    background-color: #909399;
  }
  .status__pending {
    display: block;
  }
  .status__pending .status__inner {
    border-color: #d9ecff;
    background-color: #d9ecff;
  }
  .wrap-avatar {
    .block {
      word-break: break-word;
    }
  }
  .el-menu.sidemenu {
    .el-menu-item {
      border: none;
      margin-top: 8px;
      margin-bottom: 24px;
      height: 48px !important;
      span {
        text-transform: capitalize;
      }
      svg {
        width: 30px;
      }
    }
  }
  .el-form {
    width: auto;
    padding-bottom: 0px !important;
    &.search-form {
      margin-top: 0px;
      width: 316px;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }
  }

  .el-input {
    border: 1px solid #d8d8d8;
    border-radius: 8px;
  }
  .assign-to-class {
    margin-right: 8px;
  }
  .select-all {
    margin-top: 26px;
    margin-left: 16px;
    position: absolute;
  }
}

.remove-study-set {
  color: red !important;
}

::v-deep .el-popper {
  margin-left: -75px !important;
  margin-top: 40px !important;
}

::v-deep .el-table__body,
::v-deep .el-table__footer,
::v-deep .el-table__header {
  table-layout: auto !important;
  width: 100% !important;
}

::v-deep .elsa-table-layout {
  padding-top: 0px;
}

::v-deep .el-table__column-filter-trigger i {
  font-size: 16px;
}

::v-deep .el-table .el-table-column--selection .cell {
  padding-left: 16px;
}

::v-deep .search-box.elsa-input {
  margin-top: 16px;
}

::v-deep .el-input .el-input__inner {
  padding: 24px 0px !important;
  opacity: 1 !important;
}

.header-end {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  & > div {
    margin: 0px 5px;
  }
}

.more-action-text {
  padding: 16px 0px;
  font-weight: 600;
  margin-right: 8px;
}

::v-deep .el-input {
  height: 48px !important;
}

::v-deep .el-input-group__append {
  border-radius: 40px !important;
}

::v-deep .el-table__empty-block {
  width: 100% !important;
}
</style>
